module.exports = __webpack_public_path__ + "media/assets/booking/logo-ff9d27b196cc74f4f55e87396b864d15.png";